// components/.../_buttons/G_BUTTON__token_drag_handle.tsx
import { ICON__grip_vertical_solid } from '@/assets/icons_fa';
import { PLACEHOLDER_BUTTON__bar_6 } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar_6';
import { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import { FIELD__list_token } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_token';
import React from 'react';
import { HOOK__token_drag_is_disabled } from '../HOOK__token_drag_is_disabled';

interface PROPS extends React.HTMLAttributes<HTMLDivElement> {
  field_parent: FIELD__list_token;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
}

export function G_BUTTON__token_drag_handle({ field_parent, dragHandleProps }: PROPS) {
  if (HOOK__token_drag_is_disabled(field_parent)) return render_stub();

  function render_stub() {
    return (
      <>
        <div className="hidden" {...dragHandleProps} />
        <PLACEHOLDER_BUTTON__bar_6 />
      </>
    );
  }

  return (
    <div {...dragHandleProps} className="cursor-grab active:cursor-grabbing " title="Drag to reorder">
      <ICON__grip_vertical_solid className="text-component-item-foreground size-2.5" />
    </div>
  );
}
